import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { VendaEditPage } from '@/features/venda/page/edit/VendaEditPage';
import { VendaTipoSchema } from '@/features/venda/types/VendaTipo';

const ParamsSchema = z.object({
    tipo: VendaTipoSchema,
});

// biome-ignore assist/source/useSortedKeys: breaks type inference
export const Route = createFileRoute('/a/venda/cadastrar/$tipo')({
    validateSearch: z.object({
        vendaExterna: z.boolean().optional().default(false),
    }),
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    component: Component,
});

function Component() {
    const { vendaExterna } = Route.useSearch();
    const { tipo } = Route.useParams();

    return <VendaEditPage mode='cadastrar' tipo={tipo} vendaExterna={vendaExterna} />;
}
